import React from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

interface ProfileUpdatedMailModalProps {
    open: boolean,
    setOpen: (open: boolean) => void,
}

const ProfileUpdatedMailModal = ({open, setOpen}: ProfileUpdatedMailModalProps) => {

    return (
        <>
            <Dialog
                disablePortal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    <Typography variant={"secondVariant"} fontSize={{xs: 18, sm: 20, md: 22}}>
                        Mise à jour de l'email
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{
                    minWidth: '300px'
                }}>
                    <Typography
                        variant={"secondVariant"}
                    >
                        Un mail a été envoyé sur votre nouvelle adresse e-mail. Cliquez sur le lien qu'il contient
                        pour valider la modification.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Fermer</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ProfileUpdatedMailModal